// capitalize (only) the first letter of a string
export const capitalizeFirstLetter = (string) => {
  return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
};

// truncate a string to a given length, e.g.:
// truncate('Hello, world!', 5) => 'Hello...'
// truncate('Hello, world!', 50) => 'Hello, world!'
export const truncate = (string = '', maxLength = 0) => {
  if (string.length <= maxLength || maxLength <= 0) {
    return string;
  }
  return `${string.slice(0, maxLength)}...`;
};
